import { render, staticRenderFns } from "./ShopOnlyChooseUsers.vue?vue&type=template&id=0357697e&scoped=true"
import script from "./ShopOnlyChooseUsers.vue?vue&type=script&lang=ts"
export * from "./ShopOnlyChooseUsers.vue?vue&type=script&lang=ts"
import style0 from "./ShopOnlyChooseUsers.vue?vue&type=style&index=0&id=0357697e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0357697e",
  null
  
)

export default component.exports